import { Box } from "@mui/material";

interface ImageProps {
  pictureURL?: string;
  classes: any;
}

export const Image = ({ pictureURL, classes }: ImageProps) => {
  if (!pictureURL) return null;

  return (
    <Box
      className={classes.imgBoxSquare}
      style={{
        backgroundImage: `url(${pictureURL})`,
      }}
    />
  );
};
